
manageAnimationClass();

function manageAnimationClass() {
  // const observationOpts = {
  //   root: null,
  //   rootMargin: '0px 0px -250px 0px',
  //   threshold: 0,
  // };
  const animeObjects = document.querySelectorAll('.animation--attached');
  if(animeObjects.length > 0){
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        let element = entry.target;
        let animeClass = element.getAttribute('anime-class');
        if(entry.isIntersecting){
          element.classList.add(animeClass);
        }
      });
    });
    animeObjects.forEach(function(ele){
      observer.observe(ele);
    });
    // Safety net: if IntersectionObserver fails to fire for any reason,
    // force-reveal still-hidden elements so sections never stay invisible.
    setTimeout(() => {
      document.querySelectorAll('.animation--attached:not(.active)').forEach((el) => {
        el.classList.add(el.getAttribute('anime-class') || 'active');
      });
    }, 2500);
  }
}